export default "__VITE_ASSET__CnLrKTDk__"